import { render, staticRenderFns } from "./EditTeamTargetForm.vue?vue&type=template&id=28a66194&"
import script from "./EditTeamTargetForm.vue?vue&type=script&lang=ts&"
export * from "./EditTeamTargetForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditTeamTargetForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports